import { Component, OnInit, Input } from '@angular/core';
import { Invoice } from '../../shared/models/invoice';

@Component({
  selector: 'app-invoice-out-view',
  templateUrl: './invoice-out-view.component.html',
  styleUrls: ['./invoice-out-view.component.scss']
})
export class InvoiceOutViewComponent implements OnInit {

 	@Input() invoice: Invoice;

 	constructor() { }

  	ngOnInit() {
  	}

}
